import { render, staticRenderFns } from "./OldVideoTable.vue?vue&type=template&id=79fd8d6e&scoped=true&"
import script from "./OldVideoTable.vue?vue&type=script&lang=js&"
export * from "./OldVideoTable.vue?vue&type=script&lang=js&"
import style0 from "./OldVideoTable.vue?vue&type=style&index=0&id=79fd8d6e&prod&lang=css&"
import style1 from "./OldVideoTable.vue?vue&type=style&index=1&id=79fd8d6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fd8d6e",
  null
  
)

export default component.exports